var locale = {
  placeholder: 'Select time'
};

export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/time-picker/locale/en_US.js
// module id = CVBf
// module chunks = 16